import { cn } from '@/lib/utils';

/**
 * Gabarits de la feuille « Envoyer votre liste » (lot B5, maquettes M10 et
 * D4). Actions toujours indigo (CREATOR_ACTION de creatorTokens), textes en rem, cibles d'au
 * moins 44 px, libelles jamais coupes (retour a la ligne permis).
 */

export const FOCUS = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4B47C4] focus-visible:ring-offset-2';

/** Bouton plein (une seule action principale visible). */
export const SHARE_PRIMARY = cn(
  'flex min-h-[52px] w-full items-center justify-center gap-2 rounded-button px-4 py-2 text-center text-[1rem] font-bold leading-tight text-white no-underline',
  // Valeurs de CREATOR_ACTION (creatorTokens) ecrites en clair pour Tailwind.
  'bg-[#4B47C4] hover:bg-[#3D39B0] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-[#4B47C4]',
  FOCUS,
);

/** Bouton contour encre (secondaire). */
export const SHARE_OUTLINE = cn(
  'flex min-h-[52px] items-center justify-center gap-2 rounded-button border-[1.5px] border-[#D9D5EE] bg-white px-4 py-2 text-center text-[1rem] font-bold leading-tight text-[#24215C] no-underline',
  'hover:bg-[#F7F6FD] disabled:cursor-not-allowed disabled:opacity-50',
  FOCUS,
);

/** Lien souligne indigo (« Modifier », « Avec ma messagerie »). */
export const SHARE_LINK = cn(
  'inline-flex min-h-11 items-center gap-1.5 rounded-[8px] px-1 text-[1rem] font-bold text-[#4B47C4] underline underline-offset-[3px] hover:text-[#3D39B0]',
  FOCUS,
);

/**
 * Gros bouton du premier rang (SMS, WhatsApp, Messenger, E-mail) : une ligne pleine
 * largeur de 56 px quand la place manque (320 px, texte agrandi), sinon
 * tuile de 76 px, icone au-dessus. Requetes de conteneur en rem : elles
 * suivent la taille du texte choisie par la personne.
 */
export const SHARE_TILE = cn(
  'flex min-h-14 min-w-0 items-center justify-start gap-3 rounded-button border-[1.5px] border-[#D9D5EE] bg-white px-4 py-2 text-left text-[1rem] font-bold leading-tight text-[#24215C] no-underline',
  'hover:bg-[#F7F6FD] @min-[20rem]:min-h-[76px] @min-[20rem]:flex-col @min-[20rem]:justify-center @min-[20rem]:gap-1 @min-[20rem]:px-1.5 @min-[20rem]:text-center',
  FOCUS,
);

/** Bouton contour du rang ordinateur (E-mail, WhatsApp) : 56 px. */
export const SHARE_WIDE = cn(
  'flex min-h-14 min-w-0 items-center justify-center gap-2 rounded-button border-[1.5px] border-[#D9D5EE] bg-white px-4 py-2 text-center text-[1rem] font-bold leading-tight text-[#24215C] no-underline',
  'hover:bg-[#F7F6FD] aria-expanded:border-[#4B47C4] aria-expanded:bg-[#EEEDFB]',
  FOCUS,
);

/** Carte blanche (message, envoi par Kadélio). */
export const SHARE_CARD = 'flex flex-col gap-1.5 rounded-[16px] border border-[#E6E3F5] bg-white px-3.5 py-3';

/** Encadre d'echec persistant. */
export const SHARE_FAILURE = 'flex flex-col gap-2.5 rounded-[16px] border-[1.5px] border-[#F4B4AE] bg-[#FEF3F2] p-3.5';

export const FIELD = cn(
  'w-full min-w-0 rounded-field border border-[#D9D5EE] bg-white px-3.5 text-[1rem] text-[#24215C] outline-none',
  'focus:border-[#4B47C4] focus:ring-4 focus:ring-[#EEEDFB] aria-invalid:border-[#B42318]',
);

export const LABEL = 'text-[0.875rem] font-bold text-[#24215C]';
export const HELP = 'm-0 text-[0.875rem] leading-[1.45] text-[#6A6690]';
